import { render, staticRenderFns } from "./StudentExamMapping.vue?vue&type=template&id=1227efa8&scoped=true&"
import script from "./StudentExamMapping.vue?vue&type=script&lang=js&"
export * from "./StudentExamMapping.vue?vue&type=script&lang=js&"
import style0 from "./StudentExamMapping.vue?vue&type=style&index=0&id=1227efa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1227efa8",
  null
  
)

export default component.exports